import React from "react";
import { Container, Grid, Typography } from "@material-ui/core";
import {
  useStyles,
  ResetInformationAccordion,
  VerifyInformationAccordion,
  CellphoneAccordion,
} from "./profile.module";
import "date-fns";

const Profile = () => {
  const classes = useStyles();

  return (
    <Container>
      <Grid container spacing={2} className={classes.dashboardStyle}>
        <Grid item xs={12}>
          <div className={classes.subtitleDashboard}>
            <Typography className={classes.textSubtitleDashboard}>
              My Profile
            </Typography>
          </div>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item lg={1} md={1} sm={1} xs={12}></Grid>
        <Grid item lg={10} md={10} sm={10} xs={12}>
          <ResetInformationAccordion />
          <VerifyInformationAccordion />
          <CellphoneAccordion />
        </Grid>
        <Grid item lg={1} md={1} sm={1} xs={12}></Grid>
      </Grid>
    </Container>
  );
};

export default Profile;
